"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const interactiveGraph_1 = require("./interactiveGraph");
const directedGraph_1 = require("../graph/directedGraph");
const undirectedGraph_1 = require("../graph/undirectedGraph");
const mixedGraph_1 = require("../graph/mixedGraph");
class IGraph extends interactiveGraph_1.InteractiveGraph {
    constructor(graphType, grid, canvas) {
        switch (graphType) {
            case GraphType.DIRECTED_GRAPH:
                super(new directedGraph_1.DirectedGraph(), grid, canvas);
                break;
            case GraphType.UNDIRECTED_GRAPH:
                super(new undirectedGraph_1.UndirectedGraph(), grid, canvas);
                break;
            case GraphType.MIXED_GRAPH:
                super(new mixedGraph_1.MixedGraph(), grid, canvas);
                break;
            default:
                super(new undirectedGraph_1.UndirectedGraph(), grid, canvas);
                break;
        }
    }
    rightClick(e) { }
}
exports.IGraph = IGraph;
var GraphType;
(function (GraphType) {
    GraphType[GraphType["DIRECTED_GRAPH"] = 0] = "DIRECTED_GRAPH";
    GraphType[GraphType["UNDIRECTED_GRAPH"] = 1] = "UNDIRECTED_GRAPH";
    GraphType[GraphType["MIXED_GRAPH"] = 2] = "MIXED_GRAPH";
})(GraphType = exports.GraphType || (exports.GraphType = {}));
